import BeautyPreferencesSavedModal from 'components/GlobalModals/BeautyPreferencesModal/BeautyPreferencesSavedModal/BeautyPreferencesSavedModal';

export default BeautyPreferencesSavedModal;
